<div class="dashboard-container">
  <!-- Dashboard Header - SalesSupportLeadernek és adminnak nem jelenik meg -->
  @if (!isSalesSupportLeader() && !isAdmin()) {
    <div class="dashboard-header">
      <h1>Áttekintés <span class="date-text">({{ getCurrentDateString() }})</span></h1>
    </div>
  }

  <!-- Statistics Cards - Call Center munkatársaknak és adminoknak -->
  @if (isCallCenterEmployee()) {
    <div class="stats-grid">
      @for (stat of stats; track $index) {
        <app-overview-card [stat]="stat"></app-overview-card>
      }
    </div>
  } @else if (isAdmin()) {
    <div class="stats-grid">
      @for (stat of adminStats; track $index) {
        <app-overview-card [stat]="stat"></app-overview-card>
      }
    </div>
  } @else if (isKAM()) {
    <div class="stats-grid">
      @for (stat of kamStats; track $index) {
        <app-overview-card [stat]="stat"></app-overview-card>
      }
    </div>
  }

  <!-- Tabs szekció -->
  @if (isSalesSupportLeader() || isAdmin()) {
    <!-- SalesSupportLeadernek és adminnak: 4 tab -->
    <mat-tab-group class="overview-tabs" animationDuration="200ms">

      <mat-tab label="Hét összefoglalója">
        <div class="tab-content">
          <app-week-selector [showExport]="false" (weekChanged)="onWeekChanged($event)"></app-week-selector>
          @if (!isLoadingStats && callCenterUsers.length > 0) {
            <mat-card class="stats-summary-card">
              <app-call-center-stats-table
                [weekNumber]="selectedWeek?.weekNumber || 1"
                [weekData]="selectedWeek"
                [staffMember]="null"
                [isSummaryTable]="true"
                [allStaffMembers]="callCenterUsers">
              </app-call-center-stats-table>
            </mat-card>
          }
        </div>
      </mat-tab>

      <mat-tab label="CC/KÜM Összesítő táblázat">
        <div class="tab-content statistics-tab-content">
          <app-monthly-selector
            [selectedMonth]="currentMonth"
            [selectedYear]="currentYear"
            [daysInMonth]="daysInCurrentMonth"
            [isKumMode]="isKumMode"
            [isCallCenterEmployee]="false"
            [isKumEmployee]="false"
            [isBothCcAndKum]="false"
            [showYearlyOption]="false"
            [showExport]="false"
            (monthChange)="onStatisticsMonthChange($event)"
            (yearChange)="onStatisticsYearChange($event)"
            (modeChange)="onStatisticsModeChange($event)">
          </app-monthly-selector>
          @if (!isLoadingStatistics) {
            <mat-card class="statistics-summary-card">
              <app-statistics-table
                [month]="currentMonth"
                [year]="currentYear"
                [daysInMonth]="daysInCurrentMonth"
                [metrics]="[]"
                [colleagueName]="'Összesen'"
                [userId]="0"
                [isKumMode]="isKumMode"
                [isSummaryTable]="true"
                [canEditPlan]="isSalesSupportLeader()"
                [allColleaguesWithMetrics]="colleaguesWithMetrics"
                [preloadedAllStatsMap]="preloadedStatsMap"
                [preloadedAllKumStatsMap]="preloadedKumStatsMap">
              </app-statistics-table>
            </mat-card>
          }
        </div>
      </mat-tab>

      <mat-tab label="Státusz riport">
        <div class="tab-content">
          @if (!isLoadingStatusReport) {
            <mat-card class="status-report-card">
              <mat-card-content>
                <app-status-report-table [rows]="statusReportRows"></app-status-report-table>
              </mat-card-content>
              <mat-card-actions class="status-report-actions">
                <button mat-icon-button
                        type="button"
                        [disabled]="isExportingStatusReport"
                        matTooltip="Exportálás XLSX-be"
                        aria-label="Exportálás XLSX-be"
                        (click)="onExportStatusReport()">
                  <mat-icon>download</mat-icon>
                </button>
              </mat-card-actions>
            </mat-card>
          }
        </div>
      </mat-tab>

      <mat-tab label="Logok">
        <div class="tab-content">
          <mat-card class="extended-logs-card">
            <mat-card-content>
              <app-extended-logs-wrapper
                [title]="'Legutóbbi tevékenységek'"
                [initialPageSize]="5"
                [customPageSizeOptions]="[5, 10, 25, 50]">
              </app-extended-logs-wrapper>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-tab>

    </mat-tab-group>

  } @else if (!isAdmin()) {
    <!-- CC munkatársnak / KAM-nak: csak logok, tabs nélkül -->
    <mat-card class="extended-logs-card">
      <mat-card-content>
        <app-extended-logs-wrapper
          [title]="'Legutóbbi tevékenységek'"
          [initialPageSize]="5"
          [customPageSizeOptions]="[5, 10, 25, 50]">
        </app-extended-logs-wrapper>
      </mat-card-content>
    </mat-card>
  }


</div>
